// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1gJrh","select":"Header_select__21Zk1","clinic":"Header_clinic__48B0t"};